import { useQuery } from "@tanstack/react-query";
import { getDashboardSummaryData, getMyGymMetrics } from "./metricsApi";

export function useDashboardSummaryData() {
  return useQuery({
    queryKey: ["dashboard-summary"],
    queryFn: getDashboardSummaryData,
  });
}

export function useMyGymMetrics(params: { start: string; end: string }) {
  return useQuery({
    queryKey: ["my-gym-metrics", params],
    queryFn: () => getMyGymMetrics(params),
    enabled: !!params.start && !!params.end,
  });
}
